import React, { useState } from "react";
import { Link } from "react-router-dom";
import cn from "classnames";
import styles from "./style.scss";
import EditIcon from "images/icon/edit_square_outline.svg";
import { History } from "models/AiResearch";
import CloseImage from "images/icon/btn_arrows_left.svg";
import OpenImage from "images/icon/btn_arrows_right.svg";
import HistoryActions from "../Components/HistoryActions";

interface Props {
  history?: History[] | undefined;
  selectedId: string | null;
  onClickNewChat: () => void;
  onClickHistoryItem: (talkId: string) => void;
  isOpen: boolean;
  onOpenChange: (isOpen: boolean) => void;
  onChatTitleEdit: ({
    newTitle,
    talkId
  }: {
    newTitle: string;
    talkId: string;
  }) => void;
  onChatDelete: ({ talkId }: { talkId: string }) => void;
}

// ナビゲーションコンポーネント
export const Navigation: React.FC<Props> = ({
  history,
  selectedId,
  onClickNewChat,
  onClickHistoryItem,
  isOpen,
  onOpenChange,
  onChatTitleEdit,
  onChatDelete
}) => {
  const [isMenuOpen, setIsMenuOpen] = useState<string | null>(null);
  const [menuPosition, setMenuPosition] = useState<{
    x: number;
    y: number;
  } | null>(null);

  const handleScroll = () => {
    setIsMenuOpen(null);
  };

  return (
    <div className={cn(styles.container, !isOpen && styles.closed)}>
      {!isOpen ? (
        <>
          <button
            className={styles.openButton}
            onClick={() => onOpenChange(true)}
            tabIndex={0}
          >
            <img src={OpenImage} alt="Open" />
          </button>
          <button
            className={styles.newChatIconContainer}
            onClick={onClickNewChat}
            tabIndex={0}
          >
            <img src={EditIcon} alt="Edit Icon" />
          </button>
        </>
      ) : (
        <>
          <div
            className={styles.closeButton}
            onClick={() => onOpenChange(false)}
          >
            <img src={CloseImage} alt="Close" />
          </div>
          <div className={styles.newChatContainer}>
            <Link
              to="/ai-research"
              onClick={onClickNewChat}
              className={styles.newChat}
              tabIndex={0}
            >
              <img src={EditIcon} alt="Edit Icon" />
              新しいAIリサーチを開始
            </Link>
          </div>
          <div className={styles.historyContainer} onScroll={handleScroll}>
            {history?.map(item => (
              <div
                className={cn(styles.historyItem, {
                  [styles.menuOpen]: isMenuOpen === item.talkId
                })}
                key={item.talkId}
              >
                <Link
                  to={`?talkId=${item.talkId}`}
                  onClick={() => onClickHistoryItem(item.talkId)}
                  className={cn(styles.historyLink, {
                    [styles.selected]: item.talkId === selectedId
                  })}
                >
                  <span className={styles.title}>{item.title}</span>
                </Link>
                <button
                  type="button"
                  className={styles.actionMenuButton}
                  onClick={e => {
                    e.preventDefault();
                    e.stopPropagation();
                    setIsMenuOpen(
                      isMenuOpen === item.talkId ? null : item.talkId
                    );
                    const rect = e.currentTarget.getBoundingClientRect();
                    setMenuPosition({ x: rect.right, y: rect.bottom });
                  }}
                >
                  <span className={styles.actionMenuIcon} />
                </button>
                <div
                  className={styles.historyActions}
                  style={{
                    top: menuPosition?.y,
                    left: (menuPosition?.x ?? 0) - 24
                  }}
                  onClick={e => e.stopPropagation()}
                >
                  <HistoryActions
                    isShowMenu={isMenuOpen === item.talkId}
                    chatTitle={item.title}
                    onCloseMenu={() => setIsMenuOpen(null)}
                    onChatTitleEdit={newTitle =>
                      onChatTitleEdit({ newTitle, talkId: item.talkId })
                    }
                    onChatDelete={() => onChatDelete({ talkId: item.talkId })}
                  />
                </div>
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
};
